<div class="custom-scrollbar" (mousedown)="onThumbDrag($event)">
    <div class="custom-scrollbar-thumb" [style.width.%]="thumbWidth"></div>
  </div>